export default {
    type: 'text',
    format: {},
    default: {
        logic: 'contains'
    },
    setting: {
        logic: ['contains']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Report Text',
        category: ['User', 'Plays'],
        description: 'Search keywords inside the text of a play report.',
        placeholder: 'Enter search term...',
        summarise: {
            template: {
                contains: {
                    '=': 'Play reports containing the term "{value}"',
                    '!=': 'Play reports not containing the term "{value}"'
                }
            }
        }
    }
}